export const SnackBarType = {
    SUCCESS: "SUCCESS",
    ERROR: "ERROR"
}

export const SnackBarTitles = {
    OOPS: "Oops!!"
}

export const SnackBarMessages = {
    SOMETHING_WENT_WRONG: "Something went wrong. Please try again later."
}